module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.lazy || _vm.loaded || _vm.active) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "el-tab-pane",
    attrs: {
      "aria-labelledby": ("tab-" + _vm.paneName),
      "id": ("pane-" + _vm.paneName),
      "aria-hidden": !_vm.active,
      "role": "tabpanel"
    }
  }, [_vm._t("default")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bf1ab18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tabs/tab-pane.vue
// module id = 1469
// module chunks = 124